import Badge, { badgeColor } from "@/components/atoms/Badge";
import Text from "@/components/atoms/Text";

interface DnbRiskLevelProps {
  level?: number | null;
}

export default function DnbRiskLevel({ level }: DnbRiskLevelProps) {
  switch (level) {
    case 1:
    case 2:
      return (
        <Badge color={badgeColor.primary} radius={"xs"} noTextTransform>
          {level}
        </Badge>
      );
    case 3:
      return (
        <Badge color={badgeColor.warning} radius={"xs"} noTextTransform style={{ color: "var(--color-text-primary)" }}>
          {level}
        </Badge>
      );
    case 4:
    case 5:
      return (
        <Badge color={badgeColor.error} radius={"xs"} noTextTransform>
          {level}
        </Badge>
      );
    default:
      return <Text size="sm">-</Text>;
  }
}
